import {
  UserActivityStatus,
  UserSetAvailabilityStatus,
} from '@api/generated/graphql';
import type { AgentWrapupStartedEvent } from '@servicetitan/telecom-rtcs-client';

/** Derived from AgentWrapupStartedEvent.stats - not directly exported from package */
type AgentStats = NonNullable<AgentWrapupStartedEvent['stats']>;

export type ServiceUserStats = {
  avgCallTime: number;
  lastActionAt: string;
  lastHandledAt: string;
  lastIdleAt: string;
  loginAt: string;
  missedSessions: number;
  offeredSessions: number;
  totalSessions: number;
};

export function userStatsFromAgentStats(stats: AgentStats): ServiceUserStats {
  return {
    lastActionAt: stats.lastActionTime,
    lastHandledAt: stats.lastHandledTime,
    lastIdleAt: stats.lastIdleTime,
    loginAt: stats.loginTime,
    totalSessions: stats.acceptedSessions,
    offeredSessions: stats.offeredSessions,
    missedSessions: stats.missedSessions,
    avgCallTime: stats.averageSessionMs,
  };
}

type ServiceUser = {
  id: string;
  contactCenterUserId?: string | null;
  email: string;
  name: string;
  username?: string | null;
  stats?: ServiceUserStats | null;
  /**
   * @deprecated Use both activityStatus and availabilityStatus (Phase 2).
   */
  canChangeStatus: boolean;
  /**
   * @deprecated Calculated from availabilityStatus via ServiceUserUtils.getAvailabilityStatus(user).
   */
  available: boolean;
  /**
   * @deprecated Use activityStatus (Phase 2).
   */
  availabilityState: string;
  recoveryTime?: number;
  /**
   * @deprecated Use availabilityStatus (Phase 2).
   */
  status: UserSetAvailabilityStatus;
  /**
   * @deprecated Use activityStatus (Phase 2).
   */
  originalStatus?: string;
  /**
   * @deprecated Calculated from activityStatus via ServiceUserUtils.getUserCapacity(user).
   */
  capacity: number;
  personalLine?: {
    phoneNumber?: string | null;
  } | null;

  activityStatus: UserActivityStatus;
  availabilityStatus: UserSetAvailabilityStatus;
};

export default ServiceUser;
